import apiClient from "./client";

export async function getProfile() {
  const res = await apiClient.get("/api/profile");
  if (!res.ok) throw new Error("Не вдалося отримати профіль");
  return res.json();
}

export async function updateProfile(fullName, email) {
  const res = await apiClient.post("/api/profile/update", { full_name: fullName, email });
  if (!res.ok) throw new Error("Не вдалося оновити профіль");
  return res.json();
}

export async function updateLanguage(language) {
  const res = await apiClient.patch("/api/profile/language", { language });
  if (!res.ok) throw new Error("Не вдалося оновити мову");
  return res.json();
}
